import { useState } from "react";
import { Box, Button, } from "@mui/material";
import MobileQueries from "./MobileQueries";
import WebsiteQueries from "./WebsiteQueries";

export default function Queries() {
  const [activeTab, setActiveTab] = useState("Mobile Queries");
  return (
    <>
      <Box>
        <Box display="flex" justifyContent="center" mb={2}>
          <Button
            variant={
              activeTab === "Mobile Queries"
                ? "contained"
                : "outlined"
            }
            onClick={() => setActiveTab("Mobile Queries")}
            sx={{ marginRight: 2 }}
          >
            Mobile Queries
          </Button>
          <Button
            variant={
              activeTab === "Website Queries" ? "contained" : "outlined"
            }
            onClick={() => setActiveTab("Website Queries")}
          >
            Website Queries
          </Button>
        </Box>

        {/* Conditionally render content based on activeTab */}
        {activeTab === "Mobile Queries" && (
          <Box>
            <MobileQueries />
          </Box>
        )}
        {activeTab === "Website Queries" && (
          <Box>
            <WebsiteQueries />
          </Box>
        )}
      </Box>


    </>
  );
}
